// extracted by mini-css-extract-plugin
export var actions = "_mc-d";
export var benefitCard = "_mc-a";
export var benefitIcon = "_mc-b";
export var benefitLabel = "_mc-c";
export var benefits = "_mc-9";
export var bodyText = "_mc-8";
export var closeButton = "_mc-2";
export var content = "_mc-3";
export var eyebrow = "_mc-4";
export var heading = "_mc-5";
export var image = "_mc-f";
export var imagePanel = "_mc-e";
export var modal = "_mc-0";
export var shell = "_mc-1";
export var title = "_mc-6";
export var titleOffer = "_mc-7";